import React from "react";
import {
  Edit,
  SimpleForm,
  TextInput,
  NumberInput,
  SelectInput,
  ReferenceInput,
  BooleanInput,
  required,
  minValue,
  TopToolbar,
  ShowButton,
  DeleteButton,
} from "react-admin";

const limiterTypes = [
  { id: "messages_per_month", name: "Сообщения в месяц" },
  { id: "challenges_create_or_join", name: "Челленджи" },
  { id: "ai_requests_per_day", name: "AI запросы в день" },
  { id: "storage_gb", name: "Хранилище (GB)" },
  { id: "team_members", name: "Участники команды" },
];

const limiterPeriods = [
  { id: "daily", name: "День" },
  { id: "weekly", name: "Неделя" },
  { id: "monthly", name: "Месяц" },
  { id: "yearly", name: "Год" },
  { id: "total", name: "Общий" },
];

const SubscriptionLimiterEditActions = () => (
  <TopToolbar>
    <ShowButton />
    <DeleteButton />
  </TopToolbar>
);

export const SubscriptionLimiterEdit = () => {
  return (
    <Edit
      actions={<SubscriptionLimiterEditActions />}
      title="Редактировать лимитер"
    >
      <SimpleForm>
        <ReferenceInput
          source="subscriptionPlanId"
          reference="subscriptionPlans"
          label="План подписки"
        >
          <SelectInput optionText="name" validate={[required()]} fullWidth />
        </ReferenceInput>
        <SelectInput
          source="type"
          label="Тип лимитера"
          choices={limiterTypes}
          validate={[required()]}
          fullWidth
        />
        <TextInput
          source="name"
          label="Название"
          validate={[required()]}
          fullWidth
        />
        <TextInput
          source="description"
          label="Описание"
          multiline
          rows={2}
          fullWidth
        />
        <NumberInput
          source="limitValue"
          label="Значение лимита"
          validate={[required(), minValue(0)]}
        />
        <SelectInput
          source="period"
          label="Период"
          choices={limiterPeriods}
          validate={[required()]}
        />
        <BooleanInput source="isActive" label="Активен" />
        <BooleanInput source="isHardLimit" label="Жесткий лимит" />
      </SimpleForm>
    </Edit>
  );
};
